import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {VenuePlanData} from "./venue-plan.data";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";


@Injectable()
export class VenuePlanService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }


    async getPlan(venueId: string): Promise<VenuePlanData> {
        return firstValueFrom(this.http.get<VenuePlanData>("/fonzie/customer-instance-venue/" + venueId + "/plan", {headers: this.auth.getHttpHeaderOptions()}));
    }

    async updatePlan(venueId: string, plan: VenuePlanData): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/plan", plan, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async cancelCurrentSubscription(venueId: string, cancellationReason: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/cancel-current-subscription", {cancellationReason: cancellationReason}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async changeCancellationReason(venueId: string, cancellationReason: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/change-cancellation-reason", {cancellationReason: cancellationReason}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async resumeCurrentSubscription(venueId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/resume-current-subscription", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }

    async churnCurrentSubscription(venueId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/churn-current-subscription", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
